import { seoSections } from '@/mocks/seoContent';

const sectionLinks: Record<string, string> = {
  'what-is': '/what-is-superbuy-spreadsheet/',
  'why-use': '/how-to-use-superbuy-spreadsheet/',
  'safety': '/is-superbuy-spreadsheet-safe/',
  'beginners': '/superbuy-spreadsheet-beginner-guide/',
  'shipping': '/superbuy-spreadsheet-shipping-guide/',
};

const sectionLinkLabels: Record<string, string> = {
  'what-is': 'Read Complete Guide',
  'why-use': 'Read Full Tutorial',
  'safety': 'Read Safety Guide',
  'beginners': 'Read Beginner Guide',
  'shipping': 'Read Shipping Guide',
};

export default function SeoContent() {
  return (
    <section className="w-full py-10 md:py-14 px-4 md:px-6">
      <div className="max-w-5xl mx-auto space-y-16">
        {seoSections.map((section, idx) => (
          <article
            key={section.id}
            className={`flex flex-col ${idx % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} gap-8 lg:gap-12 items-center`}
          >
            <div className="w-full lg:w-1/2">
              <div className="relative rounded-2xl overflow-hidden aspect-[4/3] bg-background-100">
                <img
                  src={section.imageUrl}
                  alt={section.imageAlt}
                  className="w-full h-full object-cover"
                  loading={idx === 0 ? 'eager' : 'lazy'}
                />
              </div>
            </div>

            <div className="w-full lg:w-1/2">
              {section.subtitle && (
                <span className="inline-block text-xs font-semibold text-accent-600 bg-accent-100 rounded-full px-3 py-1 mb-3">
                  {section.subtitle}
                </span>
              )}
              <h2 className="text-xl md:text-2xl font-heading font-semibold text-foreground-950 mb-4 leading-snug">
                {section.title}
              </h2>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                {section.content}
              </p>
              <a
                href={sectionLinks[section.id] || '/what-is-superbuy-spreadsheet/'}
                className="whitespace-nowrap inline-flex items-center gap-2 text-primary-500 hover:text-primary-600 font-medium text-sm mt-4 transition-colors cursor-pointer"
              >
                {sectionLinkLabels[section.id] || 'Read Full Guide'}
                <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
              </a>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}